import React from "react";
import MediaCardTemplate from "./MediaCardTemplate";
import PropTypes from 'prop-types';

export default function StatsFactory(props) {
  return (
    <MediaCardTemplate isLoaded={true} card={props.card} >
    </MediaCardTemplate>
  );
}

StatsFactory.propTypes = {
  card: PropTypes.shape({
    type_url: PropTypes.any,
  })
};
